import React from 'react';
import {
    STATUS_GROUP_OVERDUE,
    STATUS_GROUP_PENDING,
    STATUS_GROUP_RESOLVED,
} from '../helpers';

export const TaskListStatsCards = ({
    isVisible,
    dashboardStats,
    isDashboardCardActive,
    onDashboardCardFilter,
}) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div className="row g-2 mb-3">
            <div className="col-6 col-md-2">
                <button type="button" className={`ticket-kpi-card ticket-kpi-card--clickable ${isDashboardCardActive('TOTAL') ? 'ticket-kpi-card--active' : ''}`} onClick={() => onDashboardCardFilter('TOTAL')}>
                    {isDashboardCardActive('TOTAL') && <i className="bi bi-check2-circle ticket-kpi-card__check" />}
                    <div className="ticket-kpi-card__value">{dashboardStats.total}</div>
                    <div className="ticket-kpi-card__label">Total</div>
                </button>
            </div>
            <div className="col-6 col-md-2">
                <button type="button" className={`ticket-kpi-card ticket-kpi-card--success ticket-kpi-card--clickable ${isDashboardCardActive('NEW') ? 'ticket-kpi-card--active' : ''}`} onClick={() => onDashboardCardFilter('NEW')}>
                    {isDashboardCardActive('NEW') && <i className="bi bi-check2-circle ticket-kpi-card__check" />}
                    <div className="ticket-kpi-card__value">{dashboardStats.incoming}</div>
                    <div className="ticket-kpi-card__label">Entrantes</div>
                </button>
            </div>
            <div className="col-6 col-md-2">
                <button type="button" className={`ticket-kpi-card ticket-kpi-card--warning ticket-kpi-card--clickable ${isDashboardCardActive('IN_PROGRESS') ? 'ticket-kpi-card--active' : ''}`} onClick={() => onDashboardCardFilter('IN_PROGRESS')}>
                    {isDashboardCardActive('IN_PROGRESS') && <i className="bi bi-check2-circle ticket-kpi-card__check" />}
                    <div className="ticket-kpi-card__value">{dashboardStats.inProgress}</div>
                    <div className="ticket-kpi-card__label">En progreso</div>
                </button>
            </div>
            <div className="col-6 col-md-2">
                <button type="button" className={`ticket-kpi-card ticket-kpi-card--warning-soft ticket-kpi-card--clickable ${isDashboardCardActive(STATUS_GROUP_PENDING) ? 'ticket-kpi-card--active' : ''}`} onClick={() => onDashboardCardFilter(STATUS_GROUP_PENDING)}>
                    {isDashboardCardActive(STATUS_GROUP_PENDING) && <i className="bi bi-check2-circle ticket-kpi-card__check" />}
                    <div className="ticket-kpi-card__value">{dashboardStats.pending}</div>
                    <div className="ticket-kpi-card__label">Pendientes</div>
                </button>
            </div>
            <div className="col-6 col-md-2">
                <button type="button" className={`ticket-kpi-card ticket-kpi-card--info ticket-kpi-card--clickable ${isDashboardCardActive(STATUS_GROUP_RESOLVED) ? 'ticket-kpi-card--active' : ''}`} onClick={() => onDashboardCardFilter(STATUS_GROUP_RESOLVED)}>
                    {isDashboardCardActive(STATUS_GROUP_RESOLVED) && <i className="bi bi-check2-circle ticket-kpi-card__check" />}
                    <div className="ticket-kpi-card__value">{dashboardStats.resolved}</div>
                    <div className="ticket-kpi-card__label">Resueltos</div>
                </button>
            </div>
            <div className="col-6 col-md-2">
                <button type="button" className={`ticket-kpi-card ticket-kpi-card--danger ticket-kpi-card--clickable ${isDashboardCardActive(STATUS_GROUP_OVERDUE) ? 'ticket-kpi-card--active' : ''}`} onClick={() => onDashboardCardFilter(STATUS_GROUP_OVERDUE)}>
                    {isDashboardCardActive(STATUS_GROUP_OVERDUE) && <i className="bi bi-check2-circle ticket-kpi-card__check" />}
                    <div className="ticket-kpi-card__value">{dashboardStats.overdue}</div>
                    <div className="ticket-kpi-card__label">Vencidos</div>
                </button>
            </div>
        </div>
    );
};